module.exports = __webpack_public_path__ + "static/img/esp_8266-1.9a5449a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/esp_8266-1.svg
// module id = 8bd3
// module chunks = 0